import React from "react";
import "../assets/styles.css";

import TeamImage3 from "../assets/pad-pro-about-us-1.jpg";
import TeamImage4 from "../assets/pad-pro-about-us-2.jpg";

export default function AboutUsSectionC() {
  return (
    <section className="py-12 sm:py-16 lg:py-20 bg-gray-100" data-aos="fade-left" data-aos-duration="1000">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        
        {/* Section Header - Enhanced responsive design */}
        <div className="text-center mb-8 sm:mb-12 lg:mb-16">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl xl:text-5xl text-black mb-4 sm:mb-6 lg:mb-8 newsreader leading-tight">
            Meet Our Team
          </h2>
        </div>

        {/* Content Grid - Enhanced responsive layout */}
        <div className="space-y-12 sm:space-y-16 lg:space-y-20">
          
          {/* First Row - Text Left, Image Right */}
          <div className="flex flex-col lg:flex-row items-center lg:items-start gap-6 sm:gap-8 lg:gap-12 xl:gap-16">
            
            {/* Text Content */}
            <div className="w-full lg:w-1/2 order-2 lg:order-1">
              <div className="space-y-4 sm:space-y-6">
                <h3 className="text-lg sm:text-xl lg:text-2xl font-semibold text-black newsreader mb-4 text-center lg:text-left">
                  Highly Qualified Professionals
                </h3>
                <p className="text-sm sm:text-base lg:text-md text-gray-700 leading-relaxed text-center lg:text-left">
                  In line with our Mission Statement of "enhancing the quality of life of individuals with intellectual disabilities by providing services that address non-purposeful behaviors and skill acquisition needs in the most professional manner", <span className="text-green-600 font-semibold">PADPro employs a highly qualified staff</span> who has extensive experience in providing basic human services in daily living activities, and adequate training in behavior modification.
                </p>
              </div>
            </div>
            
            {/* Team Image 1 */}
            <div className="w-full lg:w-1/2 order-1 lg:order-2 flex justify-center lg:justify-end">
              <div className="relative max-w-sm sm:max-w-md lg:max-w-full group">
                <img
                  src={TeamImage3}
                  alt="PADPro team group showing qualified staff members"
                  className="w-full h-auto shadow-lg group-hover:shadow-2xl transition-all duration-500 transform group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-lg"></div>
              </div>
            </div>
          </div>

          {/* Second Row - Image Left, Text Right */}
          <div className="flex flex-col lg:flex-row items-center lg:items-start gap-6 sm:gap-8 lg:gap-12 xl:gap-16">
            
            {/* Team Image 2 */}
            <div className="w-full lg:w-1/2 order-1 flex justify-center lg:justify-start">
              <div className="relative max-w-sm sm:max-w-md lg:max-w-full group">
                <img
                  src={TeamImage4}
                  alt="PADPro team training session with staff members"
                  className="w-full h-auto shadow-lg group-hover:shadow-2xl transition-all duration-500 transform group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-lg"></div>
              </div>
            </div>

            {/* Text Content */}
            <div className="w-full lg:w-1/2 order-2">
              <div className="space-y-4 sm:space-y-6">
                <h3 className="text-lg sm:text-xl lg:text-2xl font-semibold text-gray-900 newsreader mb-4 text-center lg:text-left">
                  Comprehensive Training & Development
                </h3>
                <div className="space-y-4 text-black leading-relaxed">
                  <p className="text-sm sm:text-base lg:text-md text-center lg:text-left">
                    The program provides orientation training within the first 40 hours of employment on facility program design, individual program and service plans, individual rights, medication assistance, health and emergency procedures, special incident, and abuse reporting. Thereafter, <span className="text-green-600 font-semibold">all staff undergo 12 training hours</span> on related and applicable areas and topics every year. Six of these are Continuing Education Units as prescribed by the Department of Developmental Services.
                  </p>
                  
                  <p className="text-sm sm:text-base lg:text-md text-center lg:text-left">
                    PADPro also provides continuous training on Infection Prevention and Control for the latest guidelines on contagious and infectious diseases, and regular emergency preparedness drills.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="text-center border-t border-gray-200 pt-6 sm:pt-8">
            <p className="text-sm sm:text-base lg:text-md text-black leading-relaxed">
              <span className="text-green-600 font-semibold">Staffing ratio to individuals is 1:3</span>, and are required to have completed/updated FIRST AID AND CPR certificates and health screening. PADPro takes pride and values its workforce and hands out awards for outstanding performances, innovation, creativity, and 10 or 15 years loyalty.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}